"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var react_uid_1 = require("react-uid");
function useAcdcElementRegistry(_a) {
    var idProp = (_a === void 0 ? {} : _a).id;
    var autoId = "acdc-" + react_uid_1.useUID();
    var id = idProp || autoId;
    var labelId = id + "-label";
    var inputId = id + "-input";
    var inputRef = react_1.useRef(null);
    var setInputElement = react_1.useCallback(function (input) {
        inputRef.current = input;
    }, []);
    var getInputElement = react_1.useCallback(function () { return inputRef.current; }, []);
    var popupId = id + "-popup";
    var popupRef = react_1.useRef(null);
    var setPopupElement = react_1.useCallback(function (popup) {
        popupRef.current = popup;
    }, []);
    var getPopupElement = react_1.useCallback(function () { return popupRef.current; }, []);
    var scrollerRef = react_1.useRef(null);
    var setScrollerElement = react_1.useCallback(function (scroller) {
        scrollerRef.current = scroller;
    }, []);
    var getScrollerElement = react_1.useCallback(function () { return scrollerRef.current; }, []);
    var optionRefs = react_1.useRef({});
    var registerOptionElement = react_1.useCallback(function (index, element) {
        optionRefs.current[index] = element;
    }, []);
    var getOptionElement = react_1.useCallback(function (index) { return optionRefs.current[index] || null; }, []);
    var valueMap = react_1.useRef({});
    var indices = react_1.useRef({});
    var registerIndex = react_1.useCallback(function (index, value) {
        indices.current[index] = true;
        valueMap.current[index] = value;
    }, []);
    var unregisterIndex = react_1.useCallback(function (index) {
        delete indices.current[index];
    }, []);
    var getValueMap = react_1.useCallback(function () { return valueMap.current; }, []);
    var getIndices = react_1.useCallback(function () { return Object
        .keys(indices.current)
        .map(function (str) { return +str; })
        .sort(function (a, b) { return a - b; }); }, []);
    return {
        id: id,
        labelId: labelId,
        inputId: inputId,
        popupId: popupId,
        setInputElement: setInputElement,
        setPopupElement: setPopupElement,
        setScrollerElement: setScrollerElement,
        registerOptionElement: registerOptionElement,
        registerIndex: registerIndex,
        unregisterIndex: unregisterIndex,
        getInputElement: getInputElement,
        getPopupElement: getPopupElement,
        getScrollerElement: getScrollerElement,
        getOptionElement: getOptionElement,
        getValueMap: getValueMap,
        getIndices: getIndices,
    };
}
exports.default = useAcdcElementRegistry;
